<template>
	<div>
		<div class="d-flex align-items-center justify-content-between mg-b-25">
			<h3 class="df-title">Manage Companies</h3>
			<div class="d-flex">
				<!-- <router-link class="btn btn-sm btn-outline-default shadow-sm mg-l-5" :to="{ name: 'companies.new' }">
					<i data-feather="user-plus" class="wd-10 mg-r-5"></i> Create New Company
				</router-link> -->
			</div>
		</div>

        <div class="row">
            <div class="col-12 mg-t-20 mg-sm-t-25">
                <table id="companies-table" class="table">
                    <thead>
                        <tr>
							<th class="wd-5p">Company ID</th>
							<th class="wd-15p">Name</th>
							<th class="wd-15p">Email</th>
							<th class="wd-10p">Phone</th>
                            <th class="wd-10p"></th>
                        </tr>
                    </thead>
                </table>
            </div>
        </div>
	</div>
</template>

<script>
	import 'datatables.net'

	export default {
		mounted() {
			this.table = $("#companies-table").DataTable({
				processing: true,
				serverSide: true,
				ajax: {
					headers: {
						Authorization: `Bearer ${localStorage.token}`
					},
					url: "/api/companies?datatable=true",
					dataFilter: data => {
						var json = JSON.parse(data);
						return JSON.stringify(json.data);
					}
				},
				responsive: true,
				deferRender: true,
				columnDefs: [
					{
						targets: [0, -1],
						className: "text-center",
					},
					{
						targets: -1,
						orderable: false,
						render: function(data, type, row, meta) {
							return `<a href="/app/companies/${row[0]}" class="btn btn-sm btn-white shadow-sm mr-2"><i data-feather="eye" class="wd-10 mg-r-5"></i> View</a>`;
						}
					}
				],
				language: {
					searchPlaceholder: "Search...",
					sSearch: "",
					lengthMenu: "_MENU_",
					emptyTable: "No company created."
				},
				initComplete: (settings, json) => {
					feather.replace();
				},
			});
		},
		data() {
			return {
				table: null
			};
		}
	};
</script>